import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_LEAVE, ADD_LEAVE_FAILED, ADD_LEAVE_SUCCESS, LEAVE, LEAVE_FAILED, LEAVE_SUCCESS, UPDATE_LEAVE, UPDATE_LEAVE_FAILED, UPDATE_LEAVE_SUCCESS,ADD_MONTHLY_LEAVE, ADD_MONTHLY_LEAVE_FAILED, ADD_MONTHLY_LEAVE_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"
import { getUsers } from "../Users/action"
import { ADD_USERS_SUCCESS } from "../Users/actionTypes"
import { LOGIN_SUCCESS } from "../Authentication/actionTypes"

export const getLeaves = () => async (dispatch) => {
  dispatch({
    type: LEAVE,
  });
  try {
    let response = await api(`leave/leaveList`, "get", {}, getAuthHeader());
    dispatch({
      type: LEAVE_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Leave list error ====>", error);
    return dispatch({
      type: LEAVE_FAILED,
      payload: error?.message,
    });
  }
};

export const addLeave = (data, navigate) => async dispatch => {
  dispatch({
    type: ADD_LEAVE
  })
  
  try {
    let response = await api(`leave/add`, 'post', data, getAuthHeader())
    toast.success("Added Successfully");
    
    const { leaveEntries } = response?.data;
    const existingUser = JSON.parse(localStorage.getItem("user")) || {};
    let updatedUser = { ...existingUser };
    
    let totalCasualLeaveUsed = 0;
    let totalUnpaidLeaveUsed = 0;
    let isCurrentUserLeave = false;
    
    leaveEntries.forEach(leaveEntry => {
      if (leaveEntry.employee_id === existingUser.id) {
        isCurrentUserLeave = true;
        totalCasualLeaveUsed += parseFloat(leaveEntry.casual) || 0;
        totalUnpaidLeaveUsed += parseFloat(leaveEntry.unpaid) || 0;
      }
    });
    
    if (isCurrentUserLeave) {
      const currentCasualLeave = parseFloat(existingUser.casual_leave) || 0;
      const currentUnpaidLeave = parseFloat(existingUser.unpaid_leave) || 0;
      const updatedCasualLeave = Math.max(0, currentCasualLeave - totalCasualLeaveUsed);
      const updatedUnpaidLeave = currentUnpaidLeave + totalUnpaidLeaveUsed;
      
      updatedUser = {
        ...existingUser,
        casual_leave: updatedCasualLeave.toFixed(2),
        unpaid_leave: updatedUnpaidLeave.toFixed(2)
      };
      
      localStorage.setItem("user", JSON.stringify(updatedUser));
    } else {
      console.log("Employee ID mismatch - localStorage not updated");
    }
    
    dispatch({
      type: ADD_LEAVE_SUCCESS,
      payload: leaveEntries
    })
    
    dispatch({
      type: LOGIN_SUCCESS,
      payload: updatedUser
    })
    
    await dispatch(getLeaves())
    return leaveEntries
  } catch (error) {
    console.log("while Adding leave error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_LEAVE_FAILED,
      payload: error?.message
    })
  } finally {
    navigate(-1);
  }
}
export const updateLeave = (leaveIds, data, navigate) => async dispatch => {
  dispatch({
    type: UPDATE_LEAVE
  })
  
  try {
    let response = await api('leave/update', 'put', { ...data, leave_ids: leaveIds }, getAuthHeader())
    console.log('update leave data', response);
    toast.success("Updated Successfully");

    const { updated, user } = response?.data;
    
    if (updated && Array.isArray(updated)) {
      const existingUser = JSON.parse(localStorage.getItem("user")) || {};

      const currentUserLeave = updated.find(leave => 
        String(leave.employee_id) === String(existingUser.id)
      );
      
      if (currentUserLeave && currentUserLeave.user) {
      
        const updatedUser = {
          ...existingUser,
          casual_leave: parseFloat(currentUserLeave.user.casual_leave || 0).toFixed(2),
          unpaid_leave: parseFloat(currentUserLeave.user.unpaid_leave || 0).toFixed(2)
        };
        
 
        localStorage.setItem("user", JSON.stringify(updatedUser));
        
     
        dispatch({
          type: LOGIN_SUCCESS,
          payload: updatedUser
        });
        
        console.log("Updated localStorage for leave edit:", {
          casual_leave: updatedUser.casual_leave,
          unpaid_leave: updatedUser.unpaid_leave
        });
      } else if (user && Object.keys(user).length > 0 && String(user.id) === String(existingUser.id)) {
      
        const updatedUser = {
          ...existingUser,
          casual_leave: parseFloat(user.casual_leave || 0).toFixed(2),
          unpaid_leave: parseFloat(user.unpaid_leave || 0).toFixed(2)
        };
        
      
        localStorage.setItem("user", JSON.stringify(updatedUser));
        
       
        dispatch({
          type: LOGIN_SUCCESS,
          payload: updatedUser
        });
        
      } else {
        console.log("No matching user leave found for localStorage update");
      }
    }

    dispatch({
      type: UPDATE_LEAVE_SUCCESS,
      payload: response?.data
    })
    
    await dispatch(getLeaves())
    return response
  } catch (error) {
    console.log("while updating leave error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_LEAVE_FAILED,
      payload: error?.message
    })
  } finally {
    if (navigate) {
      navigate(-1);
    }
  }
}
export const addMonthlyLeave = (data, navigate) => async (dispatch) => {
  dispatch({
    type: ADD_MONTHLY_LEAVE,
  });

  try {
    let response = await api(
      `leave/add-monthly-leave`,
      "post",
      data,
      getAuthHeader()
    );
    toast.success("Monthly Leave Added Successfully");
    const { results } = response?.data;
    const existingUser = JSON.parse(localStorage.getItem("user")) || {};
    let updatedUser = { ...existingUser };
    const currentUserResult = results?.find(
      (result) => result.userId === existingUser.id
    );

    if (currentUserResult && currentUserResult.success) {
      
      updatedUser = {
        ...existingUser,
        casual_leave: parseFloat(
          currentUserResult.newCasualLeaveBalance || 0
        ).toFixed(2),
        unpaid_leave: parseFloat(
          currentUserResult.newUnpaidLeaveBalance || 0
        ).toFixed(2),
      };

      localStorage.setItem("user", JSON.stringify(updatedUser));
      console.log("Updated localStorage for monthly leave:", {
        casual_leave: updatedUser.casual_leave,
        unpaid_leave: updatedUser.unpaid_leave,
      });
    } else {
      console.log(
        "Current user not found in monthly leave results or operation failed"
      );
    }

    dispatch({
      type: ADD_MONTHLY_LEAVE_SUCCESS,
      payload: results,
    });

    dispatch({
      type: LOGIN_SUCCESS,
      payload: updatedUser,
    });

    await dispatch(getLeaves());
    return results;
  } catch (error) {
    console.log("while Adding monthly leave error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_MONTHLY_LEAVE_FAILED,
      payload: error?.message,
    });
  } finally {
    if (navigate) {
      navigate(-1);
    }
  }
};